import type { ContentRegistry } from '@/core/content/registry';

/** Tiếng lành level for a number of points (0 below Lv1), studio-nano.md §5. */
export function studioLevelFor(content: ContentRegistry, points: number): number {
  return content.balance.studio.levels.filter((t) => t <= points).length;
}
